/* Categories Section */
(function() {
  function init(section) {
    var allTabs = section.querySelectorAll('.categories__tab');
    var panels = section.querySelectorAll('.categories__panel');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    // Sync all tabs across all panels
    function syncTabs(targetHandle) {
      allTabs.forEach(function(t) {
        var isActive = t.dataset.tab === targetHandle;
        t.classList.toggle('categories__tab--active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    // Tab click handler
    allTabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var target = tab.dataset.tab;
        
        // Sync all tabs
        syncTabs(target);

        // Switch panels
        panels.forEach(function(panel) {
          var isActive = panel.dataset.panel === target;
          panel.classList.toggle('categories__panel--active', isActive);
          if (isActive) initPanel(panel, isMobile);
        });
      });
    });

    // Init first active panel
    var activePanel = section.querySelector('.categories__panel--active');
    if (activePanel) {
      initPanel(activePanel, isMobile);
      syncTabs(activePanel.dataset.panel);
    }
  }

  function initPanel(panel, isMobile) {
    // Prevent multiple initializations
    if (panel.dataset.initialized === 'true') return;
    panel.dataset.initialized = 'true';

    var items = panel.querySelectorAll('.categories__item');
    var grid = panel.querySelector('.categories__grid');
    var imageContainer = panel.querySelector('.categories__image');

    function activate(item) {
      items.forEach(function(i) { i.classList.remove('categories__item--active'); });
      item.classList.add('categories__item--active');

      var color = item.dataset.color;
      var imageSrc = item.dataset.image;

      if (grid && color) grid.style.backgroundColor = color;

      if (imageContainer) {
        var existingImg = imageContainer.querySelector('img');
        if (imageSrc) {
          if (existingImg) {
            existingImg.classList.remove('visible');
            setTimeout(function() {
              existingImg.src = imageSrc;
              existingImg.onload = function() { existingImg.classList.add('visible'); };
            }, 80);
          } else {
            var newImg = document.createElement('img');
            newImg.src = imageSrc;
            newImg.alt = '';
            newImg.onload = function() { newImg.classList.add('visible'); };
            imageContainer.appendChild(newImg);
          }
        } else if (existingImg) {
          existingImg.classList.remove('visible');
        }
      }
    }

    items.forEach(function(item) {
      if (isMobile) {
        item.addEventListener('click', function(e) {
          if (!item.classList.contains('categories__item--active')) {
            e.preventDefault();
            activate(item);
          }
        });
      } else {
        item.addEventListener('mouseenter', function() { activate(item); });
      }
    });

    // Set initial state
    var firstItem = items[0];
    if (firstItem) {
      firstItem.classList.add('categories__item--active');
      var img = imageContainer ? imageContainer.querySelector('img') : null;
      if (img && firstItem.dataset.image) {
        img.src = firstItem.dataset.image;
        img.classList.add('visible');
      }
      if (grid && firstItem.dataset.color) {
        grid.style.backgroundColor = firstItem.dataset.color;
      }
    }
  }

  function run() {
    document.querySelectorAll('.categories').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('.categories');
    if (section) {
      // Reset initialization flags
      section.querySelectorAll('.categories__panel').forEach(function(p) {
        p.dataset.initialized = 'false';
      });
      init(section);
    }
  });
})();
